import React from 'react'
import { MatxLayouts } from './index'
import { MatxSuspense } from 'app/components'
import useSettings from 'app/hooks/useSettings'
import ZLAuth from 'app/auth/zlauth'

const MatxLayout = (props) => {
    const { settings } = useSettings()
    const Layout = MatxLayouts[settings.activeLayout]

    return (
        <MatxSuspense>
            <ZLAuth>
                <Layout {...props} />
            </ZLAuth>
        </MatxSuspense>
    )
}

export default MatxLayout
